import { render, staticRenderFns } from "./PopUpModalComponentPHI.vue?vue&type=template&id=6ba4b30c&scoped=true&"
import script from "./PopUpModalComponentPHI.vue?vue&type=script&lang=ts&"
export * from "./PopUpModalComponentPHI.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpModalComponentPHI.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PopUpModalComponentPHI.vue?vue&type=style&index=1&id=6ba4b30c&lang=scss&scoped=true&"
import style2 from "./PopUpModalComponentPHI.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4b30c",
  null
  
)

export default component.exports